import { createContext } from 'react';

export const FirebaseAdminContext = createContext([]);
